module.exports = __webpack_public_path__ + "static/img/tianjian.c63553a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjian.png
// module id = MoCq
// module chunks = 19